"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const releaseUtils_1 = __importDefault(require("../release/releaseUtils"));
exports.default = (execSync, prompt, currentVersion) => {
    const exec = (command) => execSync(command, { stdio: 'inherit' });
    const mainBranch = releaseUtils_1.default.getMainBranchName(execSync);
    const releaseOrHotfix = prompt(`
  Is this a:
    1) Release
    2) Hotfix
    3) Minor/isolated Release
  Type 1, 2, or 3!
  `);
    if (!['1', '2', '3'].includes(releaseOrHotfix)) {
        console.error('You need to select 1 for release, 2 for hotfix, or 3 for a minor release. Try again!');
        process.exit(1);
    }
    const branchPrefix = releaseUtils_1.default.branchMap[releaseOrHotfix];
    if (releaseOrHotfix === releaseUtils_1.default.branchMap.release) {
        exec('git checkout develop');
    }
    else {
        exec(`git checkout ${mainBranch}`);
    }
    exec('git pull');
    const suggestedNextVersion = releaseUtils_1.default.calculateNextReleaseSemver(releaseOrHotfix, currentVersion);
    let nextVersion = prompt(`What should the next version be (current version is ${currentVersion})?
    Suggested version is ${suggestedNextVersion}.
    Leave blank and press enter for suggested version or enter a new version number: \n`);
    const re = /^\d+\.\d+\.\d+$/;
    if (!nextVersion) {
        nextVersion = suggestedNextVersion;
    }
    else if (!re.test(nextVersion)) {
        console.error('Please enter a valid semver value');
        process.exit(1);
    }
    exec(`git checkout -b ${branchPrefix}--${nextVersion}`);
    exec(`npm --no-git-tag-version version ${nextVersion}`);
    exec('git add package.json');
    try {
        exec('git add package-lock.json');
        console.log('Added package-lock.json');
    }
    catch (e) {
        console.log('Could not add package-lock.json - most likely npm-shrinkwrap.json exists instead.');
    }
    try {
        exec('git add npm-shrinkwrap.json');
        console.log('Added npm-shrinkwrap.json');
    }
    catch (e) {
        console.log('Could not add npm-shrinkwrap.json - most likely package-lock.json exists instead.');
    }
    exec(`git commit -nm "version bump ${nextVersion}"`);
    exec(`git push -u origin ${branchPrefix}--${nextVersion}`);
    console.log(`Yaaaas: ${branchPrefix} branch has been successfully ✂️`);
};
